import type {
  AdminDeleteProjectPostParams,
  AdminAuditPostInput,
  AdminListProjectPostsParams,
} from '../api'
import { api } from '../api'

const adminDeleteProjectPost = async (data: AdminDeleteProjectPostParams) => {
  return await api.v1.adminDeleteProjectPost(data)
}

const adminAuditProjectPost = async (data: AdminAuditPostInput) => {
  return await api.v1.adminAuditProjectPost(data)
}

const adminListProjectPosts = async (data: AdminListProjectPostsParams) => {
  return await api.v1.adminListProjectPosts(data)
}

export default {
  adminDeleteProjectPost,
  adminAuditProjectPost,
  adminListProjectPosts,
}
